import {QuotationStatusVisualVariant} from "../../component/quotation/quotationStatusVariant";

export const QUOTATION_STATUS = {
  DRAFT: 1,
  READY_TO_SEND: 2,
  SENT: 3,
  FOLLOW_UP: 4,
  CONFIRMED: 5,
  LOST: 6,
} as const

export const resolvePreservedSaveIntent = (status: number): QuotationStatusVisualVariant => {
  switch (status) {
    case QUOTATION_STATUS.DRAFT: return "draft";
    case QUOTATION_STATUS.READY_TO_SEND: return "ready to send";
    case QUOTATION_STATUS.SENT: return "sent";
    case QUOTATION_STATUS.FOLLOW_UP: return "follow up";
    case QUOTATION_STATUS.CONFIRMED: return "confirmed";
    case QUOTATION_STATUS.LOST: return "lost";
    default: return "default";
  }
}

export const getQuotationStatusFlags = (status: number) => ({
  isDraft: status === QUOTATION_STATUS.DRAFT,
  isReadyToSend: status === QUOTATION_STATUS.READY_TO_SEND,
  isSent: status === QUOTATION_STATUS.SENT,
  isFollowUp: status === QUOTATION_STATUS.FOLLOW_UP,
  isConfirmed: status === QUOTATION_STATUS.CONFIRMED,
  isLost: status === QUOTATION_STATUS.LOST,
})
